import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import WebLocalServerInfo from "./WebLocalServerInfo";

const WebLocalServerList = ({ currentPage, list_localServer, list_localSite, list_localServerType, isSearching, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column w-100 my-2">
            {
                // teacher/class 탭과 동일한 table-container / list-table 스타일 (내용·데이터 흐름은 동일)
                list_localServer && list_localServer.length > 0 ?
                    <div className="table-container">
                        {/* 260804-7 사이트/서버 이름 말줄임(...) 실제 동작을 위해 table-layout:fixed 적용 */}
                        <table className="list-table admin-ellipsis-table">
                            <thead>
                                <tr>
                                    {/* 260804 헤더 다국어 처리, 업데이트 상태는 상세설정 패널로만 노출하기로 해서 별도 컬럼 제거, 공간 확보를 위해 Local Site/Server Name 폭 축소 */}
                                    {/* 260804-2 "포트 상태" 두 줄로 줄바꿈되는 문제 - 폭 확대 + 헤더 전체 줄바꿈 방지 */}
                                    {/* 260804-8 table-layout:fixed 적용 후 서버 이름/인증 코드가 원래보다 좁게 잘려 보이던 문제 - 두 컬럼 폭 확대, 대신 순번/로컬 사이트/버튼 컬럼 폭 축소 */}
                                    {/* 260804-9 포트 상태 컬럼 폭을 줄이고, 그만큼을 로컬 사이트/서버 이름에 2%씩 재분배 */}
                                    {/* 20260828 다국어 키 통일: Seq -> 순번 */}
                                    <th style={{ width: '7%', whiteSpace: 'nowrap' }} className="text-center">{t("순번", { ns: "admin" })}</th>
                                    <th style={{ width: '14%', whiteSpace: 'nowrap' }} className="text-center">{t("Local_Site", { ns: "admin" })}</th>
                                    <th style={{ width: '29%', whiteSpace: 'nowrap' }} className="text-center">{t("Server_Name", { ns: "admin" })}</th>
                                    <th style={{ width: '19%', whiteSpace: 'nowrap' }} className="text-center">{t("Auth_Code", { ns: "admin" })}</th>
                                    <th style={{ width: '10%', whiteSpace: 'nowrap' }} className="text-center">{t("Port_Status", { ns: "admin" })}</th>
                                    <th style={{ width: '21%' }} className="text-center" />
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    list_localServer.map((localServer, idx) => (
                                        <WebLocalServerInfo
                                            // key={"config-local-" + idx}
                                            // 20261023 필터 변경으로 행이 이동해도 초기화 대상 서버가 뒤바뀌지 않도록 식별한다.
                                            key={`config-local-${localServer.localServerSeq}`}
                                            idx={idx}
                                            list_localSite={list_localSite}
                                            list_localServerType={list_localServerType}
                                            localServer_info={localServer}
                                            handleSelectedFunc={handleSelectedFunc}
                                        />
                                    ))
                                }
                            </tbody>
                        </table>
                    </div> :
                    <div className="d-flex view m-3 justify-content-center grey-text" style={{ fontSize: '1rem' }}>
                        {/* 20261007 검색 중이면 검색 결과 없음 문구 표시 */}
                        {isSearching ? t("로컬_서버_검색_결과_없음", { ns: "admin" }) : t("관리_가능한_로컬_서버_목록_없음", { ns: "admin" })}
                    </div>
            }
        </div>
    );
}

export default WebLocalServerList;
